// Utility functions for week/period mapping between frontend (UI) and backend

/**
 * Converts UI period (1-13) and week (1-4) to backend week (1-52)
 * @param period number (1-13)
 * @param week number (1-4)
 * @returns backend week number (1-52)
 */
export function toBackendWeek(period: number, week: number): number {
  return (period - 1) * 4 + week;
}

/**
 * Converts backend week (1-52) to UI period (1-13) and week (1-4)
 * @param backendWeek number (1-52)
 * @returns { period: number, week: number }
 */
export function fromBackendWeek(backendWeek: number): { period: number; week: number } {
  const period = Math.floor((backendWeek - 1) / 4) + 1;
  const week = ((backendWeek - 1) % 4) + 1;
  return { period, week };
}
